<label>
  <!-- @TODO allow ng-content -->
  <i class="icon-attachment ic-primary pointer" [class.ic-success]="control.value && control.valid"></i>
  <!-- @TODO allow multiple files in future -->
  <input class="receipt-input d-none" type="file" (change)="control.setValue($event.target.files[0])" />
</label>
